// extracted by mini-css-extract-plugin
export default {"header":"KycView_header__1TssR","referral":"KycView_referral__0emOh","referralText":"KycView_referralText__uIKHE"};